<template>
  <div class="container o-form-page">
    <div v-if="item.code && !!workflowInstance" class="container-fixed">
      <b-container fluid>
        <b-row>
          <b-col cols="8">
            <p
              class="d-flex flex-row justify-content-between align-items-center mod-p"
            >
              {{ item.code }} | {{ item.description }}
            </p>
          </b-col>
          <b-col cols="4">
            <template v-if="!!workflowInstance">
              <p
                class="pl-2 mod-span d-flex flex-row justify-content-center align-items-center"
                :key="index"
                v-for="(detail, index) in workflowInstanceDetail"
                variant="secondary"
              >
                <b-badge
                  class="d-flex flex-row justify-content-center align-items-center"
                  >{{ detail.state__name }}</b-badge
                >
              </p>
            </template>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div
      :class="!!workflowInstance ? 'marginTop-25' : ''"
      v-if="currentUser.role.supervisor && !currentUser.email"
    >
      <b-alert show variant="danger"
        >User {{ currentUser.username }} cannot create a request due to no
        supervisor email address has been found. Please contact SHojun
        services.</b-alert
      >
    </div>
    <o-working-overlay :working="working"></o-working-overlay>

    <o-section
      :class="!!workflowInstance ? 'marginTop-25' : ''"
      :title="title"
      @click="enableDebug($event)"
      :level="0"
    >
      <item-form
        :form-state="formState"
        :item="item"
        :server-errors="serverErrors"
        v-bind:create="create"
        @reload="reload"
        :_do-save="_doSave"
        :oldFilesLength="oldFilesLength"
      ></item-form>
    </o-section>

    <o-action-buttons
      :item="item"
      :form-state="formState"
      :create="create"
      @save="doSave"
      @saveAndClose="doSaveAndClose"
      @saveAndNew="doSaveAndNew"
      @delete="doDeleteItem"
      :show-create-and-new="true"
    >
      <o-report-button
        v-if="itemParams"
        :filename="'Repair Details Report - ' + item.id + '.pdf'"
        report-name="repair_request"
        class="ml-2 my-2"
        :params="itemParams"
        variant=""
        >Download Repair</o-report-button
      >
    </o-action-buttons>
  </div>
</template>

<script>
import {
  CreateFormPageMixin,
  CreateGroupPermissionMixin,
  UnsavedMixin,
} from "../../../vue-ocom/mixins";
import ItemForm from "../components/ItemForm.vue";
import OActionButtons from "../../../vue-ocom/components/forms/OActionButtons";
import OSection from "../../../vue-ocom/components/layout/OSection";
import OWorkingOverlay from "../../../vue-ocom/components/OWorkingOverlay";
import OReportButton from "@/vue-ocom/reports/OReportButton";
import { HasGroupMixin } from "../../../vue-ocom/auth/mixin/AuthFormMixins.js";

import _ from "lodash";

export default {
  mixins: [
    HasGroupMixin("Administrator"),

    UnsavedMixin,
    CreateFormPageMixin("ServiceRepair", "service_repair"),
    CreateGroupPermissionMixin("ServiceRepair"),
  ],
  components: {
    OReportButton,
    OSection,
    OWorkingOverlay,
    OActionButtons,
    ItemForm,
  },
  props: {
    create: { type: Boolean, default: false },
  },
  data() {
    return {
      hideCode: true,
      oldFilesLength: 0,
    };
  },

  methods: {},
  computed: {
    itemParams() {
      if (this.item.id) {
        const item = {
          service_repair_id: this.item.id,
          file_server_url: "https://ocom-shojun-test.s3.amazonaws.com/",
        };
        return item;
      }

      return null;
    },
    workflowInstanceDetail() {
      let filteredState = _.filter(
        this.item.workflow_instance_details.states,
        function (state) {
          return state.is_active;
        }
      );

      let getFirstState = [];
      // if the filteredState.length > 0 then get only the first state
      if (filteredState.length > 0) {
        getFirstState.push(filteredState[0]);
        return getFirstState;
      }

      // if the filteredState is empty it means the state have a type of END so we need to determine if it is APPROVED or ONHOLD
      else if (filteredState.length <= 0) {
        const name = this.item.workflow_instance_details.workflow_status;
        // this.item.workflow_instance_details.workflow_status == "onhold"
        //   ? "On Hold"
        //   : "Approved";
        getFirstState.push({ state__name: name });
        return getFirstState;
      }

      return [];
    },
    workflowInstance() {
      return this.item.workflow_instance;
    },
    title() {
      if (this.create) {
        return "Create Repair";
      }

      return "Edit Repair";
    },
  },
  updated() {
    if (this.item.workflow_instance) {
      this.oldFilesLength = this.item.repair_files.length;
    }
  },
};
</script>

<style scoped>
.marginTop-25 {
  margin-top: 25px;
}
.mod-p {
  padding: 5px 30px 5px 30px;
}
.mod-span {
  font-size: initial;
}
.container-fixed {
  background: #3071a9;
  color: #fff;
  width: inherit;
  border: 1px #3071a9 solid;
  position: sticky;
  top: 52px;
  z-index: 1000;
  margin-top: -10px;
}
.container-fixed p {
  margin: 0;
  line-break: anywhere;
}

@media screen and (max-width: 640px) {
  .action-buttons {
    margin-bottom: 20px;
  }

  .action-buttons div button {
    margin-bottom: 1px !important;
  }
}
</style>
